import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  defaultLimitPagination,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import { TrustSelectMulti } from "../../../components/TrustSelectMulti";
import { UserSelectMulti } from "../../../components/UserSelectMulti";
import { formatSubcontractorName } from "../../../lib/Misc";
import MainBody from "../../../components/MainBody/MainBody";
// import { useMediaQuery } from "../../../components/use-media-query";
// import { AccordionContent } from "@radix-ui/react-accordion";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionTrigger,
// } from "../../../components/ui/accordion";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import { useLocation } from "react-router-dom";
import moment from "moment";
import CustomLabelText from "../../../components/CustomLabelText";
import { Label } from "../../../components/ui/label";

const UserActivity = ({ org = false, userID }) => {
  const [loading, setLoading] = useState(false);
  const { organizationData } = useOrganization();
  const [activityData, setActivityData] = useState(null);

  const location = useLocation();
  // const isDesktop = useMediaQuery("(min-width: 768px)");
  const query = new URLSearchParams(location.search);

  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);
  const [trustId, setTrustId] = useState([]);

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userId, setUserId] = useState(userID ? [userID] : []);

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  // const [activeTrustId, setActiveTrustId] = React.useState();
  // const [activeType, setActiveType] = React.useState(null);

  // const handleAccordionChange = async (value) => {
  //   if (value[0] === organizationData?.organizationId) {
  //     setActiveType("organization");
  //   } else {
  //     setActiveType("trust");
  //   }
  //   if (!value) {
  //     setActiveTrustId(null);
  //     return;
  //   }

  //   setActiveTrustId(value);
  // };

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.business_name
          ? item?.business_name
          : item?.first_name
            ? item?.first_name + " " + item?.last_name
            : item?.last_name,
      }));

      setTrustListing(trustTempListing || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList]);

  const fetchData = useCallback(
    async (limit, page) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.USER_ACTIVITY_LOGS}?organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }
          &user_ids=${userId ? userId?.join(",") : ""}
          &trust_ids=${trustId ? trustId?.join(",") : ""}
          &page=${page ? page : 1}
          &limit=${limit ? limit : defaultLimitPagination}`,
        );

        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setActivityData(data?.data?.data);
        setLoading(false);
      } catch (e) {
        setActivityData(null);
      }
    },
    [organizationData?.organizationId, userId, trustId],
  );

  useEffect(() => {
    fetchData(defaultLimitPagination, 1);
  }, [fetchData]);

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    fetchData(limit, 1);
  };

  /**
   * Pagination
   */
  const handleChangePage = (page) => {
    fetchData(limit, page);
  };

  /**
   * Table Change For Sorting
   */
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      //   setSortField(sortField);
      //   setSortOrder(
      //     sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      //   );
    }
  };

  const columns = [
    {
      dataField: "trust",
      text: "Trust",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "date",
      text: "Date",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "email",
      text: "Email",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "activity",
      text: "Activity",
      headerClasses: THClasses,
      classes: TDClasses,
    },
  ];

  const dataGenerator = (quantity) => {
    if (quantity > 0) {
      const items = [];
      for (let i = 0; i < quantity; i++) {
        items.push({
          key: i,
          trust: activityData[i]?.trust
            ? formatSubcontractorName(activityData[i]?.trust)
            : "AML-CTF",
          date: activityData[i]?.created_at
            ? moment(activityData[i]?.created_at, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss",
              )
            : "N/A",

          name: activityData[i]?.user?.first_name
            ? activityData[i]?.user?.first_name +
              " " +
              activityData[i]?.user?.last_name
            : activityData[i]?.user?.last_name,

          email: activityData[i]?.user?.email,
          activity: activityData[i]?.activity ? (
            <span
              dangerouslySetInnerHTML={{ __html: activityData[i]?.activity }}
            ></span>
          ) : (
            "N/A"
          ),
        });
      }
      return items;
    }
  };

  const activityDatas = dataGenerator(activityData?.length);

  return (
    <MainBody
      search={false}
      expandList={org ? false : true}
      actionRight={false}
      actionContent={
        <>
          <div className="grid gap-2">
            <Label htmlFor="contact_id">
              <CustomLabelText labelText="Trust" errorField={""} />
            </Label>
            <div className="relative">
              <TrustSelectMulti
                orgId={organizationData?.organizationId}
                options={trustListing?.filter((item) => item?.value !== "new")}
                placeholder={"Select Trusts"}
                onValueChange={(e) => {
                  setTrustId(e);
                }}
                className={"bg-background"}
                variant="inverted"
                animation={2}
                maxCount={0}
                defaultValue={trustId ? trustId : ""}
                setTrustList={setTrustList} // Update vendor list as new data loads
                setTrustLoading={setTrustLoading}
                loading={trustLoading}
              />
            </div>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="contact_id">
              <CustomLabelText labelText="User" errorField={""} />
            </Label>
            <div className="relative">
              <UserSelectMulti
                orgId={organizationData?.organizationId}
                options={userListing?.filter((item) => item?.value !== "new")}
                placeholder={"Select Users"}
                onValueChange={(e) => {
                  setUserId(e);
                }}
                className={"bg-background"}
                variant="inverted"
                animation={2}
                maxCount={0}
                defaultValue={userId ? userId : ""}
                setUserList={setUserList} // Update vendor list as new data loads
                setUserLoading={setUserLoading}
                loading={userLoading}
              />
            </div>
          </div>
        </>
      }
      loading={loading}
    >
      <div className="overflow-y-auto max-h-[75vh]">
        {/* <Accordion
          type="multiple"
          value={activeTrustId}
          onValueChange={handleAccordionChange}
          collapsible
          className="w-full"
        >
          {[
            organizationData?.organizationData,
            ...trustListing?.filter(
          (item) =>
            item?.value !== "new" &&
            Array.isArray(trustId) &&
            trustId?.includes(item?.value),
        ),
          ].map((item) => {
            const trustLabel = item?.business_name
              ? item?.business_name
              : item?.first_name
                ? item?.first_name + " " + item?.last_name
                : item?.last_name;

            return (
              <AccordionItem
                key={item?.id}
                value={item?.id}
                className="border-none mb-2"
              >
                <AccordionTrigger className="text-base font-medium bg-webPrimary hover:bg-webSecondary text-white dark:bg-muted px-4 py-2 rounded-md dark:hover:bg-muted/70">
                  <div className="flex items-center justify-between w-full pr-3">
                    {trustLabel}
                    {`${item?.organization_type_id ? " (Organization)" : " (Trust)"}`}
                  </div>
                </AccordionTrigger>
                <AccordionContent> */}
        <div className="custom-table mt-2">
          <div className={"table-body-class sm:max-h-[600px] rounded-md"}>
            <BootstrapTable
              keyField="key"
              remote
              data={
                limit && page && activityDatas?.length > 0 ? activityDatas : []
              }
              columns={columns}
              onTableChange={handleTableChange}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>
        {/* </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion> */}
      </div>
    </MainBody>
  );
};

export default UserActivity;
